export default {"src":"/_next/static/media/search-mobile.ae12b296.svg","height":28,"width":28};